import http from '@/helpers/axios';
export function getNewsData (data) {
    return http.request({
      url: '/homepage_admin/news_center/list ',
      method: 'post',
      data
    });
};
export function addNews (data) {
  return http.request({
    url: '/homepage_admin/news_center',
    method: 'post',
    data
  });
};
export function deleteNews (id) {
  return http.request({
    url: `/homepage_admin/news_center/${id}`,
    method: 'delete'
 });
};
export function deleteManyNews (data) {
  return http.request({
    url: `/homepage_admin/news_center/`,
    method: 'delete',
    data
 });
};
export function changeNewsStatus (data) {
  return http.request({
    url: `/homepage_admin/news_center/dispatch`,
    method: 'post',
    data
 });
};
export function getCompanyData (data) {
  return http.request({
    url: `/homepage_admin/homepage/online_shop/list`,
    method: 'post',
    data
  });
};
export function getUserData (data) {
  return http.request({
    url: `/homepage_admin/homepage/potential/list`,
    method: 'post',
    data
  });
};
export function getNewsDetail (id) {
  return http.request({
    url: `/homepage_admin/news_center/${id} `,
    method: 'get'
 });
};
export function putNews (data) {
  return http.request({
    url: `/homepage_admin/news_center/update`,
    method: 'put',
    data
 });
};
export function uploadImage (data) {
  return http.request({
    url: `/homepage_admin/common/file/to/oss/`,
    method: 'post',
    data
  });
};
export function getCloudFactoryList (data) {
  return http.request({
    url: '/homepage_admin/homepage/cloud_factory/list',
    method: 'post',
    data
  });
};
export function getCloudFactoryDetail (id) {
  return http.request({
    url: `/homepage_admin/homepage/cloud_factory/${id}`,
    method: 'get'
 });
};
